import * as yup from "yup";

export const multiSelectSchema = yup.array().of(yup.string());

export const fileSchema = yup.array().of(yup.object());
